import {Injectable} from '@angular/core';
import {DeviceDetectorService} from "ngx-device-detector";
import {DeviceInfo} from "@shared/services/device-info/device-info";

@Injectable({
    providedIn: 'root'
})
export class DeviceInfoService {

    constructor(
        private deviceDetector: DeviceDetectorService
    ) {
    }

    public getDeviceInfo(): DeviceInfo {
        const deviceInfo = this.deviceDetector.getDeviceInfo()

        return {
            deviceType: deviceInfo.deviceType,
            deviceMake: deviceInfo.device,
            deviceModel: deviceInfo.browser,
            deviceOS: deviceInfo.os,
            deviceOSVersion: deviceInfo.os_version,
            userAgent: deviceInfo.userAgent
        }
    }
}
